var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('header',{staticClass:"jumbotron"},[_c('h3',[_vm._v(_vm._s(_vm.content))]),_c('h3',[_vm._v(_vm._s(_vm.content.id))]),_c('h3',[_vm._v(_vm._s(_vm.content.isActive))])])])}
var staticRenderFns = []

export { render, staticRenderFns }